import {createAction} from "@reduxjs/toolkit";

export const CLEAR_API = "api/clear";
export const clearApi = createAction<string>(CLEAR_API);
